<template lang="pug">
div.input
    label.tech.grey {{ label }}
    div.filename-input(@click="sFiles")
        input.input-field(:value="filename" :placeholder="placeholder" disabled)
        svg(xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25")
            path(fill="none" fill-rule="evenodd" stroke="#919191" stroke-width="1.5" d="M20.948 10.809l.152-.152a4.783 4.783 0 0 0 0-6.757 4.783 4.783 0 0 0-6.757 0L3.91 14.335a4.783 4.783 0 0 0 0 6.756 4.783 4.783 0 0 0 6.756 0l7.052-7.056a2.609 2.609 0 0 0 0-3.687 2.609 2.609 0 0 0-3.687 0l-7.39 7.391")
    input.hidden(type="file" @change="updateValue($event.target.files)" ref="fileInput")
</template>

<script>
import Input from './Input.vue';
export default {
    name: 'file-input',
    extends: Input,
    props: {
        extensions: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            filename: ""
        }
    },
    methods: {
        updateValue: function(files) {
            this.filename = files[0].name;
            this.$emit('input', files[0]);
        },
        sFiles: function() {
            console.log("test");
            this.$refs.fileInput.click();
        }
    }
}
</script>

<style lang="scss" scoped>
.hidden {
    display: none;
}
.filename-input {
    position: relative;
    cursor: pointer;
    input {
        cursor: pointer;
        padding-right: 40px;
    }
    svg {
        position: absolute;
        top: 10px;
        right: 10px;
    }
}
</style>




// WEBPACK FOOTER //
// FileInput.vue?626174c6